import { useEffect, useRef, useState } from 'react';
import { XPRESSID_IFRAME_DEV_URL, XPRESSID_IFRAME_URL } from '../constants';
import { isProdEnvironment } from 'utilities/environment';

export const useXpressIdIframe = accessToken => {
    const iframeRef = useRef(null);
    const [src, setSrc] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const baseUrl = isProdEnvironment() ? XPRESSID_IFRAME_URL : XPRESSID_IFRAME_DEV_URL;
        accessToken && setSrc(`${baseUrl}/?access_token=${accessToken}`);
    }, [accessToken]);

    const handleIframeLoad = () => {
        setIsLoading(false);
    };

    return { iframeRef, isLoading, src, handleIframeLoad };
};
